export default "/img/spike-logo-white.svg"